import { ThunkType } from "../../../../core/store/reducers";
import getSecurityEarningsApi from "../api/getSecurityEarnings";
import { setDisplayedEarnings } from "../statisticsDataSlice";
import { EarningsItem } from "../types";

// Load funkcija (reset + fetch)
export const loadSecurityEarnings = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedEarnings(undefined));

	console.log(symbol)
	const statistics = await dispatch(
		getSecurity_Earnings(symbol)
	);
	console.log(statistics)

	dispatch(setDisplayedEarnings(statistics));
};

export const getSecurity_Earnings = (
	symbol: string
): ThunkType<Promise<EarningsItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}

		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getSecurityEarningsApi(userId, symbol, "earnings")
		);

		console.log(response)
		if (!response || !response.meta) {
			return undefined;
		}
		//		const latest = response?.earnings?.[0];

		const latest = response?.earnings?.find(item =>
			item.time !== "Time Not Supplied" &&
			item.eps_actual !== null &&
			item.eps_estimate !== null
		);

		if (!latest) {
			return undefined;
		}

		return {
			symbol: response.meta.symbol,
			date: latest.date,
			time: latest.time,
			eps_estimate: latest.eps_estimate,
			eps_actual: latest.eps_actual,
			difference: latest.difference,
			surprise_prc: latest.surprise_prc,
		};
	};



